import { useEffect } from "react";
import { toast } from "sonner";
import { useLang } from "@/i18n/LanguageContext";

const rand = (n) => Math.floor(Math.random() * n);

export default function SocialProofToasts() {
  const { t } = useLang();
  useEffect(() => {
    let timer;
    const messages = t("social");
    const show = () => {
      const m = messages[rand(messages.length)];
      toast(m.t, { description: m.d, icon: "🦷", duration: 5000, className: "text-sm" });
      timer = setTimeout(show, 60000 + Math.random() * 45000);
    };
    const first = setTimeout(show, 25000);
    return () => { clearTimeout(first); clearTimeout(timer); };
  }, [t]);

  return null;
}
